module.exports = __webpack_public_path__ + "img/9788952744852.ffd351f0.jpg";